import { activeFormattingLocale, intlLocale } from "./locale";

/**
 * A count (badge, group header, "N orders") in the portal's numerals:
 * Arabic-Indic in Arabic ("٦"), Western in English. One helper so an order
 * group badge and the dashboard number beside the same label never disagree on
 * digits — they used to ("6" in the Orders list, "٦" on the dashboard).
 *
 * `locale` defaults to the active portal locale (set by `SellerIntlProvider`
 * before its children render, like `formatEgp`), so a count rendered straight
 * into JSX — where `{n}` would print Latin digits — is `{formatCount(n)}`.
 */
export function formatCount(
  value: number,
  locale: string = activeFormattingLocale(),
): string {
  return value.toLocaleString(locale ? intlLocale(locale) : undefined);
}
